export const {
    REACT_APP_API_URL,
    REACT_APP_WS_URL,
    REACT_APP_STRIPE_KEY,
    REACT_APP_FIREBASE_API_KEY,
    REACT_APP_FIREBASE_PROJECT_ID,
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    REACT_APP_FIREBASE_APP_ID,
    REACT_APP_FIREBASE_VAPID_KEY,
} = process.env;
